import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-error-toast',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './error-toast.html',
  styles: [`
    @keyframes errorToastPop {
      from { opacity: 0; transform: scale(0.9) translateY(8px); }
      to   { opacity: 1; transform: scale(1) translateY(0); }
    }
    .error-toast-pop {
      animation: errorToastPop 0.25s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
    }
    @keyframes errorToastProgress {
      from { width: 100%; }
      to   { width: 0%; }
    }
    .error-toast-progress {
      animation-name: errorToastProgress;
      animation-timing-function: linear;
      animation-fill-mode: forwards;
    }
  `],
})
export class ErrorToast implements OnChanges, OnDestroy {

  @Input() isOpen = false;
  @Input() title = 'Sign in failed';
  @Input() message = 'Invalid email or password. Please try again.';
  /** Auto-dismiss after this many ms. Set to 0 to disable auto-dismiss. */
  @Input() autoCloseMs = 5000;

  @Output() closed = new EventEmitter<void>();

  private autoCloseTimer?: ReturnType<typeof setTimeout>;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isOpen']) {
      this.clearTimer();
      if (this.isOpen && this.autoCloseMs > 0) {
        this.autoCloseTimer = setTimeout(() => this.onClose(), this.autoCloseMs);
      }
    }
  }

  ngOnDestroy(): void {
    this.clearTimer();
  }

  onClose(): void {
    this.clearTimer();
    this.closed.emit();
  }

  onBackdropClick(): void {
    this.onClose();
  }

  private clearTimer(): void {
    if (this.autoCloseTimer) {
      clearTimeout(this.autoCloseTimer);
      this.autoCloseTimer = undefined;
    }
  }
}
